import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="inversion" className="w-full bg-white py-16 md:py-24" data-id="element-108" data-mp="2jknqblhfrnqr">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-109" data-mp="1vts18w4d76n7">
        {showUrgency && <CountdownPanel headline="L’offerta di lancio termina tra:" subtext={`Dopo, il Kit tornerà al suo prezzo abituale di ${offer.listPrice}.`} data-id="element-110" data-mp="1rsgdkw51wvhn" />}

        <h2 className="mt-16 text-center text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-111" data-mp="20t4qtommerth">
          Il tuo prezzo oggi
        </h2>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-stone-50 p-7 text-center shadow-xl ring-1 ring-neutral-200 md:p-12" data-id="element-112" data-mp="3h5jsozzy0ge4">
          <p className="text-lg text-neutral-500" data-id="element-113" data-mp="3vzgpxie2equ4">
            Prezzo abituale: <span className="line-through" data-id="element-114" data-mp="3vz6ydqddgbmb">{offer.listPrice}</span>
          </p>

          <p className="mt-4 text-sm font-extrabold uppercase tracking-widest text-pink-700" data-id="element-115" data-mp="4rkr7nrg1r0p">
            Oggi
          </p>
          <p className="mt-2 text-6xl font-extrabold leading-none tracking-tight text-pink-900 md:text-7xl" data-id="element-116" data-mp="9q5q9juym4nk">
            {`${offer.price}\u00A0${offer.currency}`}
          </p>

          <p className="mt-5 inline-block rounded-lg bg-pink-200 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-pink-950" data-id="element-117" data-mp="3daim1ssyfem5">
            {offer.subtitle}
          </p>

          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-neutral-500" data-id="element-118" data-mp="3n6d70uknhls3">
            {offer.detail}
          </p>

          <div className="mt-9" data-id="element-119" data-mp="3rzy7qudmotuz">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-120" data-mp="2uipnzjz1337k">
              {offer.cta}
            </CtaButton>
          </div>
        </div>

        <TrustIcons className="mt-10" data-id="element-121" data-mp="2zfzl7lsnsj5y" />
      </div>
    </section>;
}